import Swiper, { Navigation, Thumbs } from 'swiper';

Swiper.use([Navigation, Thumbs]);

export default (id = 0) => ({

    init() {
        // Thumbnails
        var homeThumbSlider = new Swiper(this.$refs.homeThumbSlider, {
            spaceBetween: 16,
            slidesPerView: 3,
            breakpoints: {
                1024: { spaceBetween: 24 },
                1280: { spaceBetween: 40 }
            }
        });

        // Main slider
        var homeHeroSlider = new Swiper(this.$refs.homeHeroSlider, {
            spaceBetween: 0,
            slidesPerView: 1,
            loop: true,
            autoplay: {
                delay: 10000 
            },
            navigation: {
                nextEl: `.swiper-button-next`,
                prevEl: `.swiper-button-prev`,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            thumbs: {
                swiper: homeThumbSlider,
            },
        });

        
    }
})
